import * as MurmurHash3 from "imurmurhash";

export enum StyleTypes {
  Container = "container",
  Text = "text",
  Icon = "icon"
}

export enum ColorSets {
  Colors = "colors",
  Light1Colors = "light1Colors",
  Dark1Colors = "dark1Colors",
  Light2Colors = "light2Colors",
  Dark2Colors = "dark2Colors"
}

export const IdenticonColors = {
  colors: ["#1FAECE", "#44B8A8", "#91CA47", "#9378CD", "#F56D4F", "#F1C40F"],
  light1Colors: ["#4FCAE6", "#7AD5C9", "#B3E770", "#B5A1E0", "#F69781", "#F9D33C"],
  dark1Colors: ["#3192B3", "#38A495", "#6FA22E", "#7E68C2", "#E2553D", "#F0B240"],
  light2Colors: ["#91E2F4", "#A3EBE1", "#CFEFA7", "#CEC0EC", "#F8C6BB", "#F7E28B"],
  dark2Colors: ["#2C7797", "#278E80", "#5A8622", "#614CA0", "#BC3C26", "#E7963B"]
};

export const getColor = (value: string, colors: string[] = IdenticonColors.colors) => {
  const hash = MurmurHash3(value).result();
  const index = hash % colors.length;
  return colors[index];
};

export const getColorClassName = (value: string, style: StyleTypes, color: ColorSets) => {
  const hash = MurmurHash3(value).result();
  const index = hash % IdenticonColors.colors.length;
  return `${style}-${color}-${index + 1}`;
};
